import { selector } from '@/lib/selectors';
import { sortOrganizations, filterOrganizations } from '@/domain/organization/helpers';
import { organizationNotificationsSelector } from '@/domain/companies/companiesSelector';
import { organization, currentOrganizationSelector } from '@/domain/organization/organizationLeafSelectors';

export * from '@/domain/organization/organizationLeafSelectors';

export const organizationIsPaidSelector = selector(organization, (o) => o.is_paid);
export const organizationSigningsSelector = selector(organization, (o) => o.signings);
export const organizationFeaturesSelector = selector(organization, (o) => {
  return o.features;
});

const twoFAFeatures = ['two_fa'];
const ssoFeatures = ['sso', 'restrict_email_domain'];
const ipWhitelistFeatures = ['ip_whitelist'];

export const organizationFeaturesWithoutHiddenSelector = selector(organizationFeaturesSelector, (features) => {
  return features.filter((v) => v.state !== 'hidden');
});

export const organizationSecurity2FAFeaturesSelector = selector(organizationFeaturesWithoutHiddenSelector, (f) => {
  return f.filter((v, k) => twoFAFeatures.includes(k));
});

export const organizationSecuritySSOFeaturesSelector = selector(organizationFeaturesWithoutHiddenSelector, (f) =>
  f.filter((v, k) => ssoFeatures.includes(k)),
);

export const organizationSecurityIPWhitelistFeaturesSelector = selector(organizationFeaturesWithoutHiddenSelector, (f) =>
  f.filter((v, k) => ipWhitelistFeatures.includes(k)),
);
export const organizationBackupConnectionSelector = selector(organization, (o) => o.backupConnection);
export const organizationWhatsappPhoneSelector = selector(organization, (o) => o.whatsapp_phone);
export const organizationPasswordExpirationDaysSelector = selector(organization, (o) => o.expiration_days);
export const organizationDomainSelector = selector(organization, (o) => o.domain);
export const organizationIpWhitelistSelector = selector(organization, (o) => o.ip_whitelist);

// list
export const organizationListSelector = selector(organization, (o) => o.list);
export const organizationLoadedSelector = selector(organization, (o) => o.loaded);
export const organizationSortSelector = selector(organization, (o) => o.sort);
export const organizationFilterSelector = selector(organization, (o) => o.filter);
export const organizationDateFormatSelector = selector(organization, (o) => o.dateFormat);
export const organizationCountrySelector = selector(organization, (o) => o.country);

// unfiltered list
export const organizationUnfilteredListSelector = selector(
  organizationListSelector,
  organizationSortSelector,
  organizationNotificationsSelector,
  sortOrganizations,
);

export const organizationFilteredListSelector = selector(
  organizationUnfilteredListSelector,
  organizationFilterSelector,
  filterOrganizations,
);

export const currentOrganizationDataSelector = selector(
  currentOrganizationSelector,
  organizationListSelector,
  (id, list) => list.find((org) => org.id === id),
);

// checks if current org was set
export const isCurrentOrganizationSetSelector = selector(currentOrganizationSelector, (org) => org !== null);

export const userHasMultipleOrgsSelector = selector(organizationListSelector, (list) => list.size > 1);
